// src/views/Posts/hooks/usePostListForSpontaneous.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { handleApiError } from '../utils/errorHandler';

export const usePostListForSpontaneous = (userId, submissionId, resumePath, extractedInformations) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPosts = async () => {
    try {
      const endpoint = `${process.env.REACT_APP_API_URL}posts/list/${userId}/spontaneous/`;
      
      // Build query parameters
      const params = new URLSearchParams();
      if (submissionId) {
        params.append('submission_id', submissionId);
      }
      if (resumePath) {
        params.append('resume_path', resumePath);
      }
      if (extractedInformations) {
        params.append('extracted_informations', JSON.stringify(extractedInformations));
      }
      
      const url = params.toString() ? `${endpoint}?${params.toString()}` : endpoint;
      
      const response = await axios.get(url, {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      setPosts(response.data);
      console.log('total number of posts for spontaneous:', response.data.count);
      setLoading(false);
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId && (submissionId || resumePath)) {
      loadPosts();
    }
  }, [userId, submissionId, resumePath, extractedInformations]);

  return { posts, loading, setPosts, loadPosts };
};
